export default {
  default: [
    {
      name: "financeReceivers.table",
      path: "/klanten",
      component: () => import("./views/FinanceReceiversTableView.vue")
    }
  ]
};
